export default "__VITE_ASSET__r3HyFUEU__"